/* eslint-disable */
import type { firebase } from '../../../firebase/firestore';

export interface ILeadScheduledMessage {
  createdAt: firebase.firestore.Timestamp;
  id: string;
  metadata?: ILeadScheduledMessageMetadata;
  /**
   * Whether the scheduled message has been processed or not
   */
  processed: boolean;
  scheduledAt: firebase.firestore.Timestamp;
  /**
   * ID of template (under supplier/configurations)
   */
  template: string;
  type: IScheduledTemplateType;
  updatedAt?: firebase.firestore.Timestamp;
}
/**
 * Metadata currently used for scheduled messages
 */
export interface ILeadScheduledMessageMetadata {
  amount?: number;
  paymentDueDate?: {
    /**
     * Payment due date - absolute time
     */
    absolute: firebase.firestore.Timestamp;
    /**
     * Payment due date - relative to wedding date - ISO 8601 format
     * (example: -P1M for 1 month before wedding date).
     */
    relative?: string;
  };
}

/**
 * Scheduled Template Type
 */
export enum IScheduledTemplateType {
  FollowUp = 'follow-up',
  PaymentReminder = 'payment-reminder',
}
